'use client';

import { c as _c } from "react/compiler-runtime";
import posthog from 'posthog-js';
import { PostHogProvider as InternalPostHogProvider } from 'posthog-js/react';
if (typeof window !== 'undefined') {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    ui_host: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST,
    capture_pageview: false,
    // Disable automatic pageview capture, as we capture manually
    capture_pageleave: false,
    // Disable automatic pageleave capture, as we capture manually
    // Inject X-POSTHOG-SESSION-ID / X-POSTHOG-DISTINCT-ID on browser fetches whose
    // hostname matches. Every browser → backend hop in this app is same-origin
    // (callApi imports `next/headers`, so it's server-only; SWR and server actions
    // hit the Next.js page origin), so the page hostname is the only one we need.
    // PREVIEW field — see @posthog/types posthog-config.d.ts.
    addTracingHeaders: [window.location.hostname],
    session_recording: {
      // Record cross-origin vibe-app iframes into this parent recording. The
      // iframe's @nominalso/vibe-bridge sets the same flag (gated on the posthog
      // context the host pushes); without this flag here the child's forwarded
      // rrweb frames are dropped and the iframe shows up blank in replays.
      recordCrossOriginIframes: true,
      maskAllInputs: false,
      // Unmask all inputs for better session insights
      maskInputOptions: {
        password: true // 🔒 Keep password fields masked for security
      }
    }
  });
}
export default function PostHogProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <InternalPostHogProvider client={posthog}>{children}</InternalPostHogProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}